import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropdownSelectMenuItem from '@adsk/bim360-matrix-react-dropdown-select-menu-item';
import classNames from 'classnames';

import Ul from '@adsk/bim360-matrix-react-ul';
import './_DropdownSelectMenu.scss';

/**
 * A component for options menu which can be selected. This component is in use in DropdownSelect.
 */
export default class DropdownSelectMenu extends Component {
  /**
   * Constructor
   */
  constructor(props) {
    super(props);
  }
  /**
   * renderOption
   */
  renderOption(option, i) {
    const { selectedEventKey } = this.props;
    const selected = option.eventKey === selectedEventKey;
    return (
      <DropdownSelectMenuItem
        key={i}
        prefix={option.prefix}
        eventKey={option.eventKey}
        label={option.label}
        subtext={option.subtext}
        selected={selected}
        boldSelection={this.props.boldSelection}
        onClick={this.props.onChange}
        disabled={option.disabled}
      />
    );
  }

  /**
   * render
   */
  render() {
    const options = this.props.options;
    const classes = classNames('DropdownSelectMenu', this.props.className);

    return (
      <Ul className={classes}>
        {options.map((option, i) => {
          return this.renderOption(option, i);
        })}
      </Ul>
    );
  }
}

DropdownSelectMenu.propTypes = {
  /**
   * The event key of the selected option
   */
  selectedEventKey: PropTypes.string,
  /**
   * User className
   */
  className: PropTypes.string,
  /**
   * The selection options
   */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * The identifier of the option
       */
      eventKey: PropTypes.string.isRequired,
      /**
       * The text that be displayed for the option
       */
      label: PropTypes.string.isRequired,
      /**
       * The text that be displayed beneath the label
       */
      subtext: PropTypes.string,
      /**
       * Function that returns HTML
       */
      prefix: PropTypes.func,
      /**
       * Whether the option should be disabled
       */
      disabled: PropTypes.bool
    })
  ).isRequired,
  /**
   * A callback function for a selection changed event
   */
  onChange: PropTypes.func.isRequired,
  /**
   * Whether or not to make selection bold
   */
  boldSelection: PropTypes.bool
};
